import { call, put, takeEvery } from 'redux-saga/effects';
import normalize from 'jsonapi-normalizer';
import { podcastEpisodes } from '../../../api';
import { resourceReducer } from '../../utils/resourceReducer';
export const [actions, reducer, resourceSagas] = resourceReducer('podcast-episodes');

// Create the sagas for this entity
function* readPodcastEpisodes() {
  yield takeEvery(actions.indexRequestBegin, function*() {
    try {
      const result = yield call(podcastEpisodes.get);
      const normalized = normalize(result);
      yield put(actions.indexRequestSuccess(normalized));
    } catch (error) {
      yield put(actions.indexRequestFailure({ error }));
      yield put({ type: 'ERRORS/HANDLE_API_ERROR', payload: error });
    }
  });
}

export const sagas = [readPodcastEpisodes, ...resourceSagas];
